export default __webpack_public_path__ + "static/media/kit_svg6.82312c06.svg";